define('core/templates/postMediaUploadRich',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.title : stack1), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Media attachment",{"name":"gettext","hash":{},"data":data}));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<li class=\"publisher-border-color\">\n<div class=\"media-box\">\n<div class=\"media-ct\">\n<div class=\"media-surface\">\n<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" target=\"_blank\">\n<img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.thumbnailUrl : stack1), depth0))
    + "\" alt=\""
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.title : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\">\n</a>\n</div>\n</div>\n</div>\n</li>\n";
},"useData":true})

});
